interface InstallAppGateInput {
	canInstall: boolean;
	isWideScreen: boolean;
	targetCount: number;
}

const canShowAppInstalls = ({ canInstall, isWideScreen, targetCount }: InstallAppGateInput): boolean =>
	!isWideScreen && canInstall && targetCount > 0;

export type { InstallAppGateInput };
export default canShowAppInstalls;
